import { Link } from 'react-router-dom';
import { useUserStatus } from '../../context/UserStatusContext';
import ModuleEmptyState from '../dashboard/ModuleEmptyState';
import styles from './DashboardModules.module.css';

const PersonalityProfileModule = ({ digitalLegacy }) => {
  const { userStatus } = useUserStatus();

  const verificationStatus = userStatus?.verificationStatus || {};
  const isPro =
    userStatus?.planTier === 'pro' ||
    userStatus?.planTier === 'founder' ||
    userStatus?.planTier === 'vip';
  const hasBasicTest = verificationStatus.hasCompletedBasicTest;
  const hasFullTest = verificationStatus.hasCompletedFullTest;

  let statusTag;
  if (hasFullTest) {
    statusTag =
      userStatus?.planTier === 'vip' ? (
        <span className={`${styles.statusTag} ${styles.pro}`}>VIP</span>
      ) : (
        <span className={`${styles.statusTag} ${styles.pro}`}>
          Pro Verified
        </span>
      );
  } else if (hasBasicTest) {
    statusTag = (
      <span className={`${styles.statusTag} ${styles.complete}`}>Complete</span>
    );
  } else {
    statusTag = (
      <span className={`${styles.statusTag} ${styles.todo}`}>To-Do</span>
    );
  }

  const scrollToFacets = () => {
    document
      .getElementById('deep-personality-facets')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className={`${styles.moduleCard} ${hasFullTest ? styles.verifiedGold : hasBasicTest ? styles.completed : ''}`}
    >
      <div className={styles.moduleHeader}>
        <h5>Personality Profile</h5>
        {statusTag}
      </div>
      <div className={styles.moduleContent}>
        {hasFullTest ? (
          <div className={styles.emptyState}>
            <i
              className={`fas fa-check-circle ${styles.emptyStateIcon}`}
              style={{ color: '#FFD700' }}
            ></i>
            <p>You've unlocked the full 30-facet analysis.</p>
            <button
              onClick={scrollToFacets}
              className="action-button secondary"
            >
              View Details
            </button>
          </div>
        ) : hasBasicTest ? (
          <div className={styles.emptyState}>
            <span className={styles.emptyStateIcon}>⚠️</span>
            {isPro ? (
              <>
                <p>
                  Your basic personality is defined. Take the deep dive test to
                  unlock your full detailed 30-facet analysis.
                </p>
                <Link
                  to="/personality-test"
                  className="action-button secondary"
                >
                  Take Deep Dive Test
                </Link>
              </>
            ) : (
              <>
                <p>
                  Your basic personality is defined. Upgrade to unlock the full
                  detailed 30-facet analysis.
                </p>
                <Link to="/pricing" className="action-button secondary">
                  Upgrade to Pro
                </Link>
              </>
            )}
          </div>
        ) : (
          <ModuleEmptyState
            icon="fa-brain"
            text="Discover your core personality traits to make your AI more authentic."
            buttonText="Take Test"
            buttonLink="/personality-test"
          />
        )}
      </div>
    </div>
  );
};

export default PersonalityProfileModule;
